module.exports = __webpack_public_path__ + "static/media/6.7a00cf45.jpg";